<template>
    <div class="page bg-fff">
        <backTitleBar></backTitleBar>
        <div class="content fs-32 color-666">
            这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容
            这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容
            这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容
        </div>
        <div class="btn-group flex bd-top">
            <div class="flex1 btn bg-fff color-000" @click="agree(false)">不同意</div>
            <div class="flex1 btn bg-main color-fff" @click="agree(true)">同意</div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "contract",
        components:{backTitleBar},
        methods:{
            agree(bol){
                if(bol){
                    this.$router.push({name: 'shopRegisterBaseInfo'});
                }else{
                    this.$router.go(-1)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .page{
        padding-bottom: .9rem;
    }
    .content{
        padding: .2rem .32rem;
    }
    .btn-group{
        position: fixed;
        width: 100%;
        height: .88rem;
        bottom: 0;
        left: 0;
        z-index: 100;
        .btn{
            text-align: center;
            line-height: .88rem;
            font-size: .34rem;
        }
    }
</style>



// WEBPACK FOOTER //
// contract.vue?384be118